import {
  accountIdFormat,
  processingGroupIdFormat,
  sortingToteIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod";
import { ToteNamingConfigSchema } from "./tote-naming-config";

export const ProcessingGroupSchema = z.object({
  id: processingGroupIdFormat.schema,
  name: z.string(),
  createdAt: z.date(),
  updatedAt: z.date(),
  merchantAccountIds: z.array(accountIdFormat.schema),
  sortingToteCount: z.number(),
  sortingToteIds: z.array(sortingToteIdFormat.schema),
  toteNamingConfig: ToteNamingConfigSchema.nullable(),
});

export const listProcessingGroups = {
  name: "listProcessingGroups" as const,
  input: z.object({}),
  output: z.object({ processingGroups: z.array(ProcessingGroupSchema) }),
};
